import {
  TechnologyPageResource,
  TechnologyResource,
  TechnologyDetailResource,
  TechnologyListResource,
} from "../generated-api";
import ApiClient from "@/api/ampm-world";
import { formattedTechnologies } from "@/api/technologies/adapter";
import { TechnologyDetailDTO } from "./types";

export class ApiTechnologies {
  static async getTechnologies(lang: string): Promise<TechnologyResource[]> {
    const data: TechnologyListResource = await ApiClient.get(`/${lang}/technologies`);

    return formattedTechnologies(data);
  }

  static async getTechnologiesPage(lang: string): Promise<TechnologyPageResource> {
    return ApiClient.get(`/${lang}/page/technology`);
  }

  static async getDetailTechnology(id: number, lang: string): Promise<TechnologyDetailDTO> {
    const { constructor, ...rest } = await ApiClient.get<TechnologyDetailResource>(`/${lang}/technology/${id}`);

    return { ...rest, blocks: constructor };
  }
}
